import Vue from 'vue'
import ActionCard from '@/components/ui/ActionCard'
import AvatarIcon from '@/components/ui/AvatarIcon'
import BorderedCard from '@/components/ui/BorderedCard'
import LinkCard from '@/components/ui/LinkCard'
import FieldInfo from '@/components/ui/FieldInfo'
import MetricBlock from '@/components/ui/MetricBlock'
import TitleSection from '@/components/ui/TitleSection'
import TooltipViewer from '@/components/ui/TooltipViewer'
import ItemText from '@/components/ui/ItemText'

Vue.component('ActionCard', ActionCard)
Vue.component('AvatarIcon', AvatarIcon)
Vue.component('BorderedCard', BorderedCard)
Vue.component('LinkCard', LinkCard)
Vue.component('FieldInfo', FieldInfo)
Vue.component('MetricBlock', MetricBlock)
Vue.component('TitleSection', TitleSection)
Vue.component('TooltipViewer', TooltipViewer)
Vue.component('ItemText', ItemText)